<template>
  <section>
    <PageTitle title="Dashboard" v-bind:crumbs="[{href:'/home',title:'Home'},{href:'//',title:'Dashboard'}]" />
    <div class="wrapper wrapper-content animated fadeInRight">
      <div class="row">
        <div class="col-md-3">
          <div class="form-group">
            <AllRestaurants
                @update:selectedRestaurantId="fetchBranchesOfRestaurant"
                :placeholder="'All'"
                :return-value="'all'"
                :updateSelectedRestaurant="selectedRestaurant"
            />
          </div>
        </div>
        <div class="col-md-3">
          <div class="form-group">
            <label>Vendors</label>
            <select class="form-control" v-model="selectedBranch">
              <option value="all">All</option>
              <option v-for="branch in branches" v-bind:value="branch.id" v-bind:key="branch.id+'_branchchoose'">
                {{branch.areasByAreaId.name}}
              </option>
            </select>
          </div>
        </div>
        <div class="col-md-3">
          <div class="form-group">
            <label>City</label>
            <select :disabled="selectedBranch !== 'all'" v-model="selectedCity" class="form-control">
              <option value="all">All</option>
              <option v-for="city in cities" v-bind:value="city.id" v-bind:key="city.id+'_citychoose'">
                {{city.city}}
              </option>
            </select>
          </div>
        </div>
        <div class="col-md-2">
          <div class="form-group">
            <label>Date RangeDate Range</label>
            <input type="text" readonly="readonly" data-graph-id="10" placeholder="Select Date Range" id="date_range" class="form-control date_picker"/>
          </div>
        </div>
        <div class="col-md-1">
          <button style="margin-top: 25px;margin-right: 10px" class=" btn btn-info btn-sm" type="button" @click="fetchGraphs"><i class="fa fa-search"></i> search</button>
        </div>
      </div>

      <div class="col-md-12 col-sm-12">
        <div class="row row-divider">
          <h3>Date-Wise Stats</h3>
        </div>
      </div>

      <div class="row">
        <div class="col-md-2">
          <HorizontalCard title="Total Orders" :stat=totalOrders card-class="blue-bg" icon="fa fa-shopping-cart fa-5x"/>
        </div>
        <div class="col-md-2">
          <HorizontalCard title="Total Value" :stat=totalValue card-class="blue-bg" icon="fa fa-shopping-cart fa-4x" :showCurrency="true" />
        </div>
        <div class="col-md-2">
          <HorizontalCard title="Total Delivered" :stat=totalOrderDelivered card-class="navy-bg" icon="fa fa-line-chart fa-5x"/>
        </div>
        <div class="col-md-2">
          <HorizontalCard title="Total Revenue" :stat=getRevenue card-class="navy-bg" icon="fa fa-line-chart fa-5x" :showCurrency="true"/>
        </div>
        <div class="col-md-2">
          <HorizontalCard title="Orders Cancelled" :stat=totalOrderCancelled card-class="red-bg" icon="fa fa-cart-arrow-down fa-5x"/>
        </div>
        <div class="col-md-2">
          <HorizontalCard title="Total Loss" :stat=getLoss card-class="red-bg" icon="fa fa-cart-arrow-down fa-5x" :showCurrency="true"/>
        </div>

      </div>

      <div class="row">

        <div class="col-md-6 col-sm-12">
          <div class="panel panel-primary">
            <div class="panel-heading">
              Date-wise Orders
            </div>
            <div class="panel-body">
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group">
                    <label>Date Range</label>
                    <input type="text" readonly="readonly" data-graph-id="1" id="date_range_1"  placeholder="Select Date Range" class="form-control date_picker"/>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <Loader class="d-flex" v-if="!loader.includes('dateWiseCount')"/>
                  <LineChart :title="'Orders Chart'" :side-text="'Total number of orders'" :bottom-text="'Dates'" :data="dataWiseCountSeries" :categories="dataWiseCountCategories" v-else/>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-6 col-sm-12">
          <div class="panel panel-primary">
            <div class="panel-heading">
              Date-wise Sales
            </div>
            <div class="panel-body">
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group">
                    <label>Date Range</label>
                    <input type="text" readonly="readonly" data-graph-id="2" id="date_range_2"  placeholder="Select Date Range" class="form-control date_picker"/>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <Loader class="d-flex" v-if="!loader.includes('dateWiseSale')"/>
                  <LineChart :title="'Sales Chart'" :side-text="'Total value'" :bottom-text="'Dates'" :data="dataWiseSeries" :categories="dataWiseSaleCategories" v-else/>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>

      <div class="row">


        <div class="col-md-6 col-sm-12">
          <div class="panel panel-primary">
            <div class="panel-heading">
              Top 10 Selling Areas
            </div>
            <div class="panel-body">
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group">
                    <label>Date Range</label>
                    <input type="text" readonly="readonly" data-graph-id="4" id="date_range_4"  placeholder="Select Date Range" class="form-control date_picker"/>
                  </div>
                </div>
              </div>
              <Loader class="d-flex" v-if="!loader.includes('topAreas')"/>
              <BarChart :title="'Top 10 Selling Areas'" :side-text="'Number of order'" :bottom-text="'Top 10 Areas'" :data="topAreasData" :categories="topAreasCategories" :color="'#3a8854'" :tooltip-format="'type2'" v-else/>
            </div>
          </div>
        </div>

        <div class="col-md-6 col-sm-12">
          <div class="panel panel-primary">
            <div class="panel-heading">
              Top 10 Products Stats
            </div>
            <div class="panel-body">
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group">
                    <label>Date Range</label>
                    <input type="text" readonly="readonly" data-graph-id="5" id="date_range_5"  placeholder="Select Date Range" class="form-control date_picker"/>
                  </div>
                </div>
              </div>
              <Loader class="d-flex" v-if="!loader.includes('topProducts')"/>
              <BarChart :title="'Top 10 Products Chart'" :side-text="'Number of Unit Sold'" :bottom-text="'Top 10 Products'" :data="topProductsData" :categories="topProductsCategories" :tooltip-format="'type2'" v-else/>
            </div>
          </div>
        </div>

      </div>

      <div class="row">

        <div class="col-md-6 col-sm-12">
          <div class="panel panel-primary">
            <div class="panel-heading">
              Sale Channel
            </div>
            <div class="panel-body">
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group">
                    <label>Date Range</label>
                    <input type="text" readonly="readonly" data-graph-id="3" id="date_range_3"  placeholder="Select Date Range" class="form-control date_picker"/>
                  </div>
                </div>
              </div>
              <Loader class="d-flex" v-if="!loader.includes('branchWiseOrders')"/>
              <PieChart :title="'Sale Channel Chart'" :side-text="''" :bottom-text="''" :data="branchWiseOrder" v-else/>
            </div>
          </div>
        </div>

        <div class="col-md-6 col-sm-12">
          <div class="panel panel-primary">
            <div class="panel-heading">
              Orders by Cancellation Reasons
            </div>
            <div class="panel-body">
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group">
                    <label>Date Range</label>
                    <input type="text" readonly="readonly" data-graph-id="6" id="date_range_6"  placeholder="Select Date Range" class="form-control date_picker"/>
                  </div>
                </div>
              </div>
              <Loader class="d-flex" v-if="!loader.includes('topCancellationReasons')"/>
              <BarChart :title="'Orders by Cancellation Reasons'" :side-text="'Number of Units'" :data="topCancellationReasonsData" :categories="topCancellationReasonsCategories" :tooltip-format="'type2'" v-else/>
            </div>
          </div>
        </div>

      </div>


      <div class="row">

        <div class="col-md-6 col-sm-12">
          <div class="panel panel-primary">
            <div class="panel-heading">
              City wise Sales of Orders
            </div>
            <div class="panel-body">
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group">
                    <label>Date Range</label>
                    <input type="text" readonly="readonly" data-graph-id="7" id="date_range_7"  placeholder="Select Date Range" class="form-control date_picker"/>
                  </div>
                </div>
              </div>
              <Loader class="d-flex" v-if="!loader.includes('cityWiseOrderSales')"/>
              <BarChart :title="'City wise Sales of Orders'" :side-text="'Number of Units'" :data="cityWiseOrderSalesData" :categories="cityWiseOrderSalesCategories" :tooltip-format="'type2'" v-else/>
            </div>
          </div>
        </div>

        <div class="col-md-6 col-sm-12">
          <div class="panel panel-primary">
            <div class="panel-heading">
              City wise Number of Orders
            </div>
            <div class="panel-body">
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group">
                    <label>Date Range</label>
                    <input type="text" readonly="readonly" data-graph-id="8" id="date_range_8" placeholder="Select Date Range" class="form-control date_picker"/>
                  </div>
                </div>
              </div>
              <Loader class="d-flex" v-if="!loader.includes('cityWiseOrderNumber')"/>
              <BarChart :title="'City wise Number of Orders'" :side-text="'Number of Units'" :data="cityWiseOrderNumberData" :categories="cityWiseOrderNumberCategories" :tooltip-format="'type2'" v-else/>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-12 col-sm-12">
        <div class="row row-divider">
          <h3>Top 10 Products Stats</h3>
        </div>
      </div>

      <div class="row" >

        <div v-for="(categoryData, index) in topCategoryProductsData" :key="index">
          <div class="col-md-6 col-sm-12">
            <div class="panel panel-primary">
              <div class="panel-heading">
                Top 10 Products Stats - {{ categoryData.title }}
              </div>
              <div class="panel-body">
                <div class="row">
                  <div class="col-md-12">
                    <div class="form-group">
                      <label>Date Range</label>
                      <input type="text" readonly="readonly"
                             :data-graph-id="rerenderChartInitialSize + index"
                             :id="'date_range_' + (rerenderChartInitialSize + index)"
                             placeholder="Select Date Range" class="form-control date_picker"/>
                    </div>
                  </div>
                </div>
                <Loader class="d-flex" v-if="!categoryData.value"/>
                <div v-else>
                  <BarChart :title="categoryData.title" :side-text="'Number of Units Sold'" :data="categoryData.value" :categories="categoryData.category" :tooltip-format="'type2'" :index="(rerenderChartInitialSize + index)"/>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>


      <div class="col-md-12 col-sm-12">
        <div class="row row-divider">
                <h3>Last Six Months Sales</h3>
          </div>
      </div>

      <div class="row" >

        <div class="col-md-6 col-sm-12">
          <div class="panel panel-primary">
            <div class="panel-heading">
              Sale of Last Six Months
            </div>
            <div class="panel-body">
              <Loader class="d-flex" v-if="!loader.includes('monthlySale')"/>
              <BarChart :title="'Sale of Last Six Months Chart'" type="bar" :unit="'Rs.'" :side-text="'Sales'" :bottom-text="'Monthly Sale'" :data="monthlySaleData" :categories="monthlySaleCategories" :height="400"  v-else/>
            </div>
          </div>
        </div>

        <div class="col-md-6 col-sm-12">
          <div class="panel panel-primary">
            <div class="panel-heading">
              Return Customer Rate
            </div>
            <div class="panel-body">
              <div class="row">
                <div class="col-md-12">
              <Loader class="d-flex" v-if="!loader.includes('newCustomers')"/>
              <BarChart :title="'Return Customer Rate Chart'" :side-text="'Number of Customers'" :data="newCustomersData" :categories="newCustomersCategories" :height="400"  v-else/>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>

      <div class="row">

        <div class="col-md-6 col-sm-12">
          <div class="panel panel-primary">
            <div class="panel-heading">
              Average Order Count
            </div>
            <div class="panel-body">
              <div class="row">
                <div class="col-md-12">
                  <Loader class="d-flex" v-if="!loader.includes('averageOrdersCountPerMonth')"/>
                  <BarChart :title="'Average Order Count Chart'" :side-text="'Average Order'" :data="averageCountData" :categories="averageSalesCountCategories" :height="400"  v-else/>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-6 col-sm-12">
          <div class="panel panel-primary">
            <div class="panel-heading">
              Average Order Sale
            </div>
            <div class="panel-body">
              <div class="row">
                <div class="col-md-12">
                  <Loader class="d-flex" v-if="!loader.includes('averageOrdersValuePerMonth')"/>
                  <BarChart :title="'Average Order Sale Chart'" :side-text="'Average Order'" :data="averageSalesValueData" :categories="averageSalesCountCategories" :height="400"  v-else/>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>

    </div>
    <CustomerDetails ref="CustomerDetailsPopUp"/>
  </section>


</template>
<script>

import PageTitle from "@/components/layout_components/PageTitle.vue";
import HorizontalCard from "@/components/Dashboard/HorizontalCard.vue";
import AllRestaurants from "@/components/restaurants/AllRestaurants.vue";
import {getAllBranchesOfRestaurant, getAllRestaurant} from "@/api/restaurants";
import {getAllCities} from "@/api/areas";
import moment from "moment/moment";
import LineChart from "@/components/Dashboard/LineChart.vue";
import BarChart from "@/components/Dashboard/BarChart.vue";
import PieChart from "@/components/Dashboard/PieChart.vue";
import {highCharts} from "highcharts-vue";
import {
  getBranchWiseOrderSum, getDateWiseOrderCount,
  getDateWiseSale, getGlobalStats,
  getNewCustomers, getSaleOfLastSixMonth,
  getTopProducts, getAverageOrdersCountandValuePerMonth,
  getTopSellingAreas, getTopCancellationReasons,
  getCityWiseOrderSalesNumber
} from "@/api/dashboard";
import Loader from "@/components/utils/Loader.vue";
import Multiselect from "vue-multiselect";
import {getAllUsers} from "@/api/users";
import CustomerDetails from "@/components/customers/CustomerDetails.vue";
import {getCategoriesNames} from "@/api/categories";

export default{

  name: "Dashboard",
  components: {
    CustomerDetails,
    Multiselect, highCharts, LineChart, AllRestaurants, HorizontalCard, PageTitle, BarChart, PieChart, Loader},
  data () {
    return {
      selectedRestaurant: "all",
      selectedBranch: "all",
      selectedCity: "all",
      defaultDate: "",
      loggedInUserRole: "",
      totalOrders: 0,
      totalValue: 0,
      totalOrderDelivered: 0,
      getRevenue: 0,
      totalOrderCancelled: 0,
      getLoss: 0,
      loader: [],
      restaurants: [],
      branches: [],
      cities: [],

      dataWiseCountSeries: [],
      dataWiseCountCategories: [],

      dataWiseSeries: [],
      dataWiseSaleCategories: [],

      averageCountData: [],
      averageSalesValueData: [],
      averageSalesCountCategories: [],

      averageSalesData: [],
      averageSalesCategories: [],

      branchWiseOrder: [],

      topProductsData: [],
      topProductsCategories: [],

      topCancellationReasonsData: [],
      topCancellationReasonsCategories: [],

      cityWiseOrderSalesData: [],
      cityWiseOrderSalesCategories: [],

      cityWiseOrderNumberData: [],
      cityWiseOrderNumberCategories: [],

      topCategoryProductsData: [],
      topCategoryProductsCategories: [],

      topAreasData: [],
      topAreasCategories: [],

      monthlySaleData: [],
      monthlySaleCategories: [],

      newCustomersData: [],
      newCustomersCategories: [],

      rerenderChartInitialSize: 0,

      rerenderChart: {
        'date_range_1': this.fetchDateWiseCountGraphs.bind(this),
        'date_range_2': this.fetchDateWiseSalesGraphs.bind(this),
        'date_range_3': this.fetchBranchWiseOrders.bind(this),
        'date_range_4': this.fetchTopAreas.bind(this),
        'date_range_5': this.fetchTopProducts.bind(this),
        'date_range_6': this.fetchTopCancellationReasons.bind(this),
        'date_range_7': this.fetchCityWiseOrderSales.bind(this),
        'date_range_8': this.fetchCityWiseOrderNumber.bind(this),

      }
    }
  },

  created: function () {
    this.loggedInUserRole = this.$store.state.user.userRolesById[0].role.split('_')[1];
    $("body").removeClass("gray-bg");
    if (this.loggedInUserRole === 'AGENT') {
      this.$router.replace("/orders");
    }
    if (this.loggedInUserRole === 'ADMIN') {
      this.fetchAllRestaurants()
      this.getAllUsers()
    } else if (this.loggedInUserRole === 'USER') {
      this.selectedRestaurant = this.$store.state.user.restaurant.id;
      this.restaurants.push({id: this.$store.state.user.restaurant.id, name: this.$store.state.user.restaurant.name})
      this.fetchBranchesOfRestaurant(this.selectedRestaurant);
    }
    this.fetchCites()

    this.rerenderChartInitialSize = Object.keys(this.rerenderChart).length + 1;

  },

  mounted: function () {
    this.setDateRange()
    this.$nextTick(() => {
      this.fetchGraphs();
    });

    },

  methods: {

    async fetchAllRestaurants() {
      let allRestaurantResp = await getAllRestaurant();
      this.restaurants = allRestaurantResp.data;
    },

    async getAllUsers() {
      let resp = await getAllUsers();
      this.agents = resp.data && resp.data.length>0 && resp.data.filter(user => user.role === 'ROLE_AGENT');
    },

    async fetchBranchesOfRestaurant(event) {
      this.selectedRestaurant = event;
      if (this.selectedRestaurant !== "all") {
        let params = new URLSearchParams();
        params.append("restaurant_id", this.selectedRestaurant);
        let restaurantAllBranch = await getAllBranchesOfRestaurant(params);
        this.branches = restaurantAllBranch.data;
      } else {
        this.branches = [];
      }
      this.selectedBranch = "all";
    },

    async fetchCites() {
      let resp = await getAllCities()
      this.cities = resp.data;
    },

    async fetchGraphs() {
      this.defaultDate = $('#date_range').val();
      $('.date_picker').val(this.defaultDate);

      this.fetchGlobalStats();
      this.fetchDateWiseCountGraphs();
      this.fetchDateWiseSalesGraphs();
      this.AverageOrdersCountPerMonth();
      this.AverageOrdersValuePerMonth();
      this.fetchTopAreas();
      this.fetchTopProducts();
      this.fetchTopCancellationReasons();
      this.fetchCityWiseOrderSales();
      this.fetchCityWiseOrderNumber();

      await this.fetchTopCategoryProducts();

      this.fetchBranchWiseOrders();
      this.fetchSaleOfLastSixMonth();
      this.fetchNewCustomersOfLastSixMonth();
      this.fetchTopCategoryProductsStats();
    },

      restaurantBranchAndCityFilters() {
        return {
          restaurant_id: this.selectedRestaurant,
          branch_id: this.selectedBranch,
          city_id: this.selectedCity
        }
      },

    createParams(id) {
      let dateRange = $('#date_range_' + id).val().split(" <==> ")

      if (dateRange[0] === '') {
        swal("Error!", "Kindly Select Date Range", "error");
        return;
      }
      return {
        start: dateRange[0],
        end: dateRange[1],
        restaurant_id: this.selectedRestaurant,
        branch_id: this.selectedBranch,
        city_id: this.selectedCity
      }
    },

    async fetchGlobalStats() {
      try {
      let params = this.createParams(1)
      const { data } = await getGlobalStats(params)
      console.log(data)
      this.totalOrders = data.totalOrders
      this.totalValue = data.totalValue
        this.totalOrderDelivered= data.totalOrderDelivered
      this.getRevenue = data.getRevenue
      this.totalOrderCancelled = data.totalCancelOrders
        this.getLoss= data.getLoss

      } catch (e) {
        console.log(e)
      }
    },

    async fetchDateWiseCountGraphs() {
      try {
        this.loader.includes("dateWiseCount") && this.loader.splice(this.loader.indexOf("dateWiseCount"), 1)
        let params = this.createParams(1)
        const resp = await getDateWiseOrderCount(params)
        this.dataWiseCountSeries.splice(0);
        this.dataWiseCountSeries.push(
            {
              name: 'Total number of orders',
              color: '#1c84c6',
              data: resp.data.series
            },
            {
              name: 'Cancelled orders',
              color: '#ed5565',
              data: resp.data.canceled
            },
            {
              name: 'Delivered orders',
              color: '#1ab394',
              data: resp.data.delivered
            }

        )

        this.dataWiseCountCategories = resp.data.categories.map(e=>this.$moment(e).format("DD-MMM-YYYY").toLowerCase())
        this.loader.push("dateWiseCount")


      } catch (e) {
        console.log(e)
      }

    },

    async fetchDateWiseSalesGraphs() {
      try {
        this.loader.includes("dateWiseSale") && this.loader.splice(this.loader.indexOf("dateWiseSale"), 1)
        let params = this.createParams(2)
        const resp = await getDateWiseSale(params)
        this.dataWiseSeries.splice(0);
        this.dataWiseSeries.push(
            {
              name: 'Total value',
              color: '#1c84c6',
              data: resp.data.series
            },
            {
              name: 'Cancelled value',
              color: '#ed5565',
              data: resp.data.canceled
            },
            {
              name: 'Delivered value',
              color: '#1ab394',
              data: resp.data.delivered
            }

        )

        this.dataWiseSaleCategories = resp.data.categories.map(e=>this.$moment(e).format("DD-MMM-YYYY").toLowerCase())
        this.loader.push("dateWiseSale")


      } catch (e) {
        console.log(e)
      }

    },

    async AverageOrdersCountPerMonth() {
      try {
        this.loader.includes("averageOrdersCountPerMonth") && this.loader.splice(this.loader.indexOf("averageOrdersCountPerMonth"), 1)
        let params = this.restaurantBranchAndCityFilters()
        const resp = await getAverageOrdersCountandValuePerMonth(params)

        this.averageCountData.splice(0);
        this.averageCountData.push(
            {
              name: 'Average Order Count',
              color: '#D05541',
              data: resp.data.avg_orders_per_month
            }

        )

        this.averageSalesCountCategories = resp.data.categories
        this.loader.push("averageOrdersCountPerMonth")

      } catch (e) {
        console.log(e)
      }
    },
    async AverageOrdersValuePerMonth() {
      try {
        this.loader.includes("averageOrdersValuePerMonth") && this.loader.splice(this.loader.indexOf("averageOrdersValuePerMonth"), 1)
        let params = this.restaurantBranchAndCityFilters()
        const resp = await getAverageOrdersCountandValuePerMonth(params)

        this.averageSalesValueData.splice(0);
        this.averageSalesValueData.push(
            {
              name: 'Average Order Sales',
              color: '#5863C6',
              data: resp.data.avg_value_per_month
            }

        )

        this.averageSalesCountCategories = resp.data.categories
        this.loader.push("averageOrdersValuePerMonth")

      } catch (e) {
        console.log(e)
      }
    },

    async fetchTopAreas() {
      try {
        this.loader.includes("topAreas") && this.loader.splice(this.loader.indexOf("topAreas"), 1)
        let params = this.createParams(4)
        const resp = await getTopSellingAreas(params)

        this.topAreasData.splice(0);
        this.topAreasData.push(
            {
              name: 'No of Orders',
              color: '#F28F43',
              data: resp.data.series
            }
        )

        this.topAreasCategories= resp.data.categories
        this.loader.push("topAreas")
      } catch (e) {
        console.log(e)
      }
    },

    async fetchTopProducts() {
      try {
        this.loader.includes("topProducts") && this.loader.splice(this.loader.indexOf("topProducts"), 1)
        let params = this.createParams(5)
        params.category = null
        const resp = await getTopProducts(params)

        this.topProductsData.splice(0);
        this.topProductsData.push(
            {
              name: 'No of Orders',
              color: '#5863C6',
              data: resp.data.series
            }
        )

        this.topProductsCategories= resp.data.categories
        this.loader.push("topProducts")

      } catch (e) {
        console.log(e)
      }
    },

    async fetchTopCancellationReasons() {
      try {
        this.loader.includes("topCancellationReasons") && this.loader.splice(this.loader.indexOf("topCancellationReasons"), 1)
        let params = this.createParams(6)

        const resp = await getTopCancellationReasons(params)

        this.topCancellationReasonsData.splice(0);
        this.topCancellationReasonsData.push(
            {
              name: 'No of Orders',
              color: '#05b292',
              data: resp.data.series
            }
        )

        this.topCancellationReasonsCategories= resp.data.categories
        this.loader.push("topCancellationReasons")

      } catch (e) {
        console.log(e)
      }
    },

    async fetchCityWiseOrderSales() {
      try {
        this.loader.includes("cityWiseOrderSales") && this.loader.splice(this.loader.indexOf("cityWiseOrderSales"), 1)
        let params = this.createParams(7)

        const resp = await getCityWiseOrderSalesNumber(params)

        this.cityWiseOrderSalesData.splice(0);
        this.cityWiseOrderSalesData.push({
          name: 'Sales',
          color: '#5c9105',
          data: resp.data.sales
        });
        this.cityWiseOrderSalesCategories = resp.data.categories;

        this.loader.push("cityWiseOrderSales");
      } catch (e) {
        console.log(e);
      }
    },

    async fetchCityWiseOrderNumber() {
      try {
        this.loader.includes("cityWiseOrderNumber") && this.loader.splice(this.loader.indexOf("cityWiseOrderNumber"), 1)
        let params = this.createParams(8)

        const resp = await getCityWiseOrderSalesNumber(params)

        this.cityWiseOrderNumberData.splice(0);
        this.cityWiseOrderNumberData.push(
            {
              name: 'No of Orders',
              color: '#5c9105',
              data: resp.data.series
            }
        )

        this.cityWiseOrderNumberCategories= resp.data.categories
        this.loader.push("cityWiseOrderNumber")

      } catch (e) {
        console.log(e)
      }
    },


    async fetchTopCategoryProducts() {
      try {
        const resp = await getCategoriesNames();
        const categories = resp.data.body;
        const initialRerenderChartSize = this.rerenderChartInitialSize;

        for (let i = 0; i < categories.length; i++) {
          const category = categories[i];

          this.loader.includes(category) && this.loader.splice(this.loader.indexOf(category), 1);

          const values = {
            name: 'No of Orders',
            color: '#5863C6',
            data: null,
          };

          this.topCategoryProductsData.splice(i);
          this.topCategoryProductsData.push({
            title: category,
            value: [values],
            category: null,
          });

          this.$set(this.rerenderChart, `date_range_${initialRerenderChartSize + i}`, () => this.fetchTopCategoryProductsStats(i));
          // Set the default date and initialize date pickers after updating the data
          this.defaultDate = $('#date_range').val();
          this.$nextTick(() => {
            $('.date_picker').val(this.defaultDate);

            // Re-initialize date pickers if needed
            this.setDateRange();
          });

        }

      } catch (e) {
        console.error(e); // Use console.error for errors
      }

    },

    async fetchTopCategoryProductsStats(index = null) {
      try {
        const startIndex = index !== null ? index : 0;
        const endIndex = index !== null ? index + 1 : this.topCategoryProductsData.length;
        const initialRerenderChartSize = this.rerenderChartInitialSize;


        for (let i = startIndex; i < endIndex; i++) {
          const category = this.topCategoryProductsData[i].title;

          if (this.loader.includes(category)) {
            this.loader.splice(this.loader.indexOf(category), 1);
          }

          const params = this.createParams(initialRerenderChartSize+i);
          params.category = category;

          const productResp = await getTopProducts(params);

          const values = {
            name: 'No of Orders',
            color: '#5863C6',
            data: productResp.data.series,
          };

          // Update the value and category of the corresponding entry
          this.$set(this.topCategoryProductsData, i, {
            title: category,
            value: [values],
            category: productResp.data.categories,
          });

        }
      } catch (e) {
        console.error('Error fetching product data for categories:', e);
      }
    },

    async fetchBranchWiseOrders() {
      try {
        this.loader.includes("branchWiseOrders") && this.loader.splice(this.loader.indexOf("branchWiseOrders"), 1)
        let params = this.createParams(3)
        const resp = await getBranchWiseOrderSum(params)
        this.branchWiseOrder = resp.data
        this.loader.push("branchWiseOrders")
      } catch (e) {
        console.log(e)
      }

    },


    async fetchSaleOfLastSixMonth() {
      try {
        this.loader.includes("monthlySale") && this.loader.splice(this.loader.indexOf("monthlySale"), 1)
        let params = this.restaurantBranchAndCityFilters()
        const resp = await getSaleOfLastSixMonth(params)

        this.monthlySaleData.splice(0);
        this.monthlySaleData.push(
            {
              name: 'Sales',
              color: '#1c84c6',
              data: resp.data.series
            },
            {
              name: 'Cancelled',
              color: '#ed5565',
              data: resp.data.canceled
            },
            {
              name: 'Delivered orders',
              color: '#1ab394',
              data: resp.data.delivered
            }

        )

        this.monthlySaleCategories = resp.data.categories
        this.loader.push("monthlySale")

      } catch (e) {
        console.log(e)
      }
    },

    async fetchNewCustomersOfLastSixMonth() {
      try {
        this.loader.includes("newCustomers") && this.loader.splice(this.loader.indexOf("newCustomers"), 1);
        let params = this.createParams(1);
        const resp = await getNewCustomers(params);

        this.newCustomersData.splice(0);
        this.newCustomersData.push(
            {
              name: 'New Customers',
              color: '#5c9105',
              data: resp.data.new_customers
            },
            {
              name: 'Returning Customer',
              color: '#038b96',
              data: resp.data.return_rate
            },
            {
              name: 'Average Percentage',
              color: '#af4e03',
              data: resp.data.average
            }
        );
        this.newCustomersCategories = resp.data.categories;

        this.loader.push("newCustomers");
      } catch (e) {
        console.log(e);
      }
    },

    setDateRange() {
      const self = this;
      let currentDate = moment();
      let minDate = currentDate.clone().subtract(3, 'months');
      let maxDate = currentDate.clone();

      // Adjust minDate and maxDate to include entire current day
      minDate.startOf('day');
      maxDate.endOf('day');

      // Check if there's a previously selected date range, otherwise default to last 7 days
      let startDate = self.defaultDate ? moment(self.defaultDate.split(' <==> ')[0]) : moment().subtract(6, 'days');
      let endDate = self.defaultDate ? moment(self.defaultDate.split(' <==> ')[1]) : currentDate;

      $('.date_picker').daterangepicker({
        format: 'YYYY-MM-DD',
        startDate: startDate,
        endDate: endDate,
        minDate: minDate,
        maxDate: maxDate,
        ranges: {
          'Today': [currentDate.clone(), currentDate.clone()],
          'Yesterday': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
          'Last 7 Days': [moment().subtract(6, 'days'), moment()],
          'Last 30 Days': [moment().subtract(29, 'days'), moment()],
          'This Month': [moment().startOf('month'), moment().endOf('month')],
          'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
        },
      }).on('apply.daterangepicker', function(ev, picker) {
        $(this).val(picker.startDate.format('YYYY-MM-DD') + ' <==> ' + picker.endDate.format('YYYY-MM-DD'));
        let id = $(this).attr("id");
        self.defaultDate = picker.startDate.format('YYYY-MM-DD') + ' <==> ' + picker.endDate.format('YYYY-MM-DD');

        if (id !== 'date_range') {
          self.rerenderChart[id]();
        }
      });
      $('#date_range').val(startDate.format('YYYY-MM-DD') + ' <==> ' + endDate.format('YYYY-MM-DD'));
    }
  }
}
</script>
<style scoped>

.row-divider {
  border-bottom: 2px solid #ccc;
  margin-bottom: 20px;
  padding-bottom: 05px;
}
.d-flex {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>